import { getAvailablePaymentMethods } from "app/pages/Booking/Payment/paymentSelector";
import { useSelector, shallowEqual } from "react-redux";
import PaymentDescription from "app/pages/.shared/DynamicBlocks/blocks/PaymentDescriptionBlock/PaymentDescription";
import { getPaymentDescriptionBlock } from "app/reducers/partnerSelector";

const mapStateToProps = state => {
	const paymentDescriptionBlock = getPaymentDescriptionBlock(state);
	return {
		availablePaymentMethods: getAvailablePaymentMethods(state),
		message: paymentDescriptionBlock?.description,
	};
};

const PaymentDescriptionContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <PaymentDescription {...props} {...stateProps} />;
};

export default PaymentDescriptionContainer;
